import { values } from 'ramda'
import PropMapper from '@v/util/PropMapper.js'

export default class BookingForEditorApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'PlanboardModel', instance: this, rawModel })
      .mapString('OpeningDateTime')
      .mapString('ClosingDateTime')
      .mapArray('Resources', x => new ResourcesApiModel(x))
  }
}

class ResourcesApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'ResourcesApiModel', instance: this, rawModel })
      .mapArray('ChildResourceKeys', x => x)
      .mapArray('BookingProducts', x => new BookingProductApiModel(x))
      .mapString('ClosingDateTime')
      .mapString('OpeningDateTime')
      .mapString('ParentResourceKey')
      .mapString('ParentResourceName')
      .mapString('ResourceAbbreviation')
      .mapString('ResourceColor')
      .mapString('ResourceKey')
      .mapString('ResourceName')
      .mapString('ResourceType')
      .mapString('Exclusivity')
      .mapArray('Timeslots', x => new TimeslotApiModel(x))
  }
}

class TimeslotApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'TimeslotApiModel', instance: this, rawModel })
      .mapBool('Available')
      .mapArray('BookedProductKeys', x => x)
      .mapString('Duration')
      .mapString('EndTime')
      .mapString('Exclusivity')
      .mapBool('KeepEmpty')
      .mapString('Label')
      .mapNumber('MaxRemainingVisitorCapacity')
      .mapString('StartTime')
      .mapNumber('TotalCapacity')
      .mapNumber('TotalCapacityWithoutReset')
      .mapNumber('UsedCapacity')
      .mapNumber('UsedResetCapacity')
      .mapNumber('UsedVisitorCapacity')
      .mapNumber('MaxRemainingVisitorCapacity')
  }
}

class BookingProductApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'BookingProductApiModel', instance: this, rawModel })
      .mapString('Exclusivity')
      .mapString('BookingKey')
      .mapString('BookingNumber')
      .mapString('BookingProductKey')
      .mapString('CustomerName')
      .mapString('EndTime')
      .mapString('ProductGroupKey')
      .mapString('ProductGroupName')
      .mapString('ProductKey')
      .mapString('ProductName')
      .mapString('SegmentAvatar')
      .mapString('StartTime')
      .mapNumber('Quantity')
      .mapNumber('NumberOfPersonsInBooking')
      .mapNumber('BookingAmount')
      .mapNumber('BookingAmountPaid')
      .mapBool('BookingFullyPaid')
      .mapBool('MultiActivity')
      .mapBool('BookingHasNotes')
      .mapBool('BookingCheckedIn')
  }
}
